import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import Vector1 from "../assets/signup/Vector1.png";
import { AppleFilled, EyeInvisibleOutlined, EyeTwoTone, GoogleOutlined, MessageOutlined } from '@ant-design/icons';
import Navbar from '../components/Navbar';
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { useDispatch, useSelector } from 'react-redux';
import { registerOtp, registerVerifyOtp } from '../redux/authSlice';
import { Input, Modal } from 'antd';
import { useTranslation } from 'react-i18next';

const SignUpOtp = () => {

  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const [isModalCode, setIsModalCode] = useState(false);

  const showModalCode = () => {
    setIsModalCode(true);
  };
  const handleOkCode = () => {
    setIsModalCode(false);
  };
  const handleCancelCode = () => {
    setIsModalCode(false);
  };

  const [phone, setPhone] = useState("");
  const [type, setType] = useState("sign_up");
  const [code, setCode] = useState("");

  const [serverCode, setServerCode] = useState("");

  const handleCodeChange = (e) => {
    let input = e.target.value;

    input = input.replace(/\s/g, "");

    if (/^\d*$/.test(input) && input.length <= 6) {
      const formattedInput = input.split("").join(" ");
      setCode(formattedInput);
    }
  };


  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { isLoading, error } = useSelector((state) => state.auth);

  const handleConfirm = (e) => {
    e.preventDefault();

    if (!phone || phone.replace(/\D/g, '').length < 5) {
      alert(t("Phone number is required!"));
      return;
    }
    else {
      dispatch(registerOtp({ phone, type }))
        .unwrap()
        .then((res) => {
          showModalCode();
          setServerCode(res.code);
        })
        .catch((err) => {
          // alert(t("Failed to send OTP. Please try again."));
          // alert(error);
        });
    }

  };

  const handleVerify = (e) => {
    e.preventDefault();

    if (!phone) {
      alert(t("Phone number is required!"));
      return;
    }

    const formattedCode = code.replace(/\s/g, "");

    if (formattedCode.length !== 6) {
      alert(t("The verification code must be 6 digits."));
      return;
    }

    // dispatch(registerVerifyOtp({ code: formattedCode, type }))
    //   .unwrap()
    //   .then(() => {
    //     setIsModalCode(false);
    //     navigate('/signup', { state: { code: formattedCode } });
    //   })
    //   .catch((error) => {
    //     alert(t("Verification failed. Please try again."));
    //     // alert(error);
    //     // console.error("Verification failed:", error);
    //     // alert(
    //     //   typeof error === "string"
    //     //     ? error
    //     //     : error?.message || JSON.stringify(error) || "Verification failed. Please try again."
    //     // );
    //   });

    dispatch(registerVerifyOtp({ code: formattedCode, type }))
      .unwrap()
      .then((res) => {
        console.log(res.message);
        setIsModalCode(false);
        navigate('/signup', { state: { code: formattedCode, phone } });
      })
      .catch((err) => {
        alert(typeof err === "string" ? err : err?.message || "Verification failed");
      });

  };

  return (
    <>
      <Navbar />
      <div className='px-20 max-lg:px-5 grid grid-cols-2 max-lg:grid-cols-1 gap-10 lg:items-center relative pb-7'>
        <div>
          <h1 className="text-[#14294F] text-4xl max-lg:text-2xl lg:mt-24 max-lg:mt-10 font-bold  leading-relaxed mx-auto text-center">
            {t("CREATE AN ACCOUNT &")} <br />  {t("UNLOCK CONVENIENCE")}
          </h1>
          <img src={Vector1} className={`w-[400px] h-[270px] absolute ${language == "en" ? "left-80 top-5" : "left-96 bottom-3"} z-10 max-lg:hidden`} />
          <p className="text-[#737E91] text-lg mt-10 max-lg:mt-10 mx-auto text-center">
            {t("When agreeing to creating an account, You agree to our Terms & Conditions and Privacy Policy")}
          </p>
          <p className="text-[#14294F] text-lg mt-5 w-1/2 mx-auto text-center">
            {t("Already on Samoolah?")}
            <Link to="/signin" className="text-[#FE9B71]"> {t("SIGN IN")}</Link></p>
        </div>
        <div className='bg-[#FCFBFA] rounded-2xl'>
          <h3 className="text-[#14294F] text-2xl font-bold mt-5 leading-relaxed mx-auto text-center">
            {t("Sign Up")}
          </h3>

          <form className="my-5 mx-7 max-lg:mx-3">
            <div className="bg-white border-2 border-[#EAA182] rounded-3xl p-7">
              <div>
                <p className="text-[#283D63] font-semibold">
                  {t("Phone Number")} <span className="text-[#CC0F0F]">*</span>
                </p>

                <div dir="ltr">
                  <PhoneInput
                    defaultCountry="sa"
                    value={phone}
                    onChange={(phone) => setPhone(phone)}
                    className="bg-white w-full p-2 rounded placeholder:text-black placeholder:text-xl placeholder:font-normal"
                  />
                </div>

              </div>
              <button
                type="submit"
                onClick={handleConfirm}
                className="bg-[#FE9B71] text-white rounded-full px-14 py-3 mt-8 flex mx-auto font-semibold"
                disabled={isLoading}
              >
                {isLoading ? t("Processing...") : t("Send a code")}
              </button>
              <Modal
                title={t("The verification code")}
                className="orderModal orderModalPricing w_small_modal"
                open={isModalCode}
                onOk={handleOkCode}
                onCancel={handleCancelCode}
                footer={null}
              >
                <form
                  className="mx-5 my-5">

                  {/* <p className="text-center text-lg font-semibold text-[#FE9B71]">
                    {serverCode}
                  </p> */}

                  <div className='mt-5' dir='ltr'>
                    <Input
                      placeholder="000000"
                      className="h-[50px] w-[90px] mt-2 border-0 bg-[#F9FBFC] mx-auto flex justify-center"
                      value={code}
                      onChange={handleCodeChange}
                      maxLength={11}
                      aria-label="Verification code input"
                      required
                    />
                  </div>

                  <button
                    type="submit"
                    onClick={handleVerify}
                    className="bg-[#FE9B71] text-white rounded-full py-2 px-10 flex mx-auto font-medium text-lg mt-5"
                    disabled={isLoading}
                  >
                    {isLoading ? t("Verifying...") : t("Confirm")}
                  </button>
                </form>
              </Modal>

              {error && (
                <p className="text-red-500 text-center mt-4">{error}</p>
              )}
            </div>
          </form>

          {/* <h3 className='text-2xl text-[#EAA182] text-center'> {t("OR")}</h3>
          <div className='flex justify-around	mt-2 mb-7'>
            <div className='border-2 border-[#EAA182] rounded-2xl w-[90px] h-[90px] flex justify-center items-center'>
              <AppleFilled className='text-5xl text-[#EAA182] ' />
            </div>
            <div className='border-2 border-[#EAA182] rounded-2xl w-[90px] h-[90px] flex justify-center items-center'>
              <GoogleOutlined className='text-5xl text-[#EAA182]' />
            </div>
          </div> */}
        </div>
      </div>
    </>
  )
}

export default SignUpOtp;